// 表单缓存 — 401 时自动保存表单数据，登录后恢复
// 避免用户填写一半被踢到登录页后输入丢失
//
// 来源：frontend/src/utils/formCache.ts（v2 迁移自旧前端）
// 说明：底层实际落在 localStorage（经 safe-storage 包装，兼容隐私模式）；旧注释写的
//      sessionStorage 与实现不符，这里按事实更正，行为不变。
// v2 差异：hasFormData 支持不传 key（用于会话过期弹窗判断「是否存在任何未提交草稿」）。

import { safeGetItem, safeSetItem, safeRemoveItem } from "./session-events";

const PREFIX = "form_cache:";

/** 缓存表单数据（401 时调用） */
export function cacheFormData(formKey: string, data: unknown): void {
  try {
    safeSetItem(PREFIX + formKey, JSON.stringify(data));
  } catch {
    // 序列化失败静默忽略
  }
}

/** 恢复表单数据（登录后/页面加载时调用） */
export function restoreFormData<T = Record<string, unknown>>(formKey: string): T | null {
  try {
    const raw = safeGetItem(PREFIX + formKey);
    if (!raw) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

/** 清除已恢复的表单数据 */
export function clearFormData(formKey: string): void {
  safeRemoveItem(PREFIX + formKey);
}

/**
 * 检查是否有缓存数据。
 * 不传 formKey 时扫描是否存在任意表单草稿——会话过期弹窗用它决定提示文案。
 */
export function hasFormData(formKey?: string): boolean {
  if (formKey) return safeGetItem(PREFIX + formKey) !== null;
  try {
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(PREFIX)) return true;
    }
  } catch {
    return false;
  }
  return false;
}
